import React, { useEffect} from "react";
import { Table } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import { getSalaryAdditionList, doSalaryAdditionDelete } from "../../../../redux/salaryaddition/salaryAdditionState";
import { NumberFormatter, handleTableChange } from "../../../../utils/index";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";
import SalaryAdditionForm from "./SalaryAdditionForm";
import PopupButton from "components/button/PopupButton";

const SalaryAdditionTable = ({ recordList, pagination, doSearch, filters, doDelete, ...props }) => { 	
  	const { getColumnSearchProps } = ColumnSearchFilter();
  	const columns = [
		{
	        title: `Employee ID`,
	        dataIndex: 'emp_code',
	        key: 'emp_code',
	        width: '10%',
	        render:(emp_code) => <span>{emp_code}</span> 
	    },
		{
	        title: `Employee`,
	        dataIndex: 'sdn_employee_name',
	        key: 'sdn_employee_name',
	        width: '19%',
	        sorter: true,
	        ...getColumnSearchProps('sdn_employee_name'),
	        render:(sdn_employee_name) => <span>{sdn_employee_name}</span>
	    },
	    {
	        title: `Date`,
	        dataIndex: 'sdn_start_date',
	        key: 'sdn_start_date',
	        width: '16%',
	        render:(sdn_start_date, record) => <span>{`${sdn_start_date} - ${record.sdn_end_date}`}</span>  
	    },
	    {
	        title: `Paycode`,
	        dataIndex: 'sdn_paycode_name',
	        key: 'sdn_paycode_name',
	        width: '15%',	
	        ...getColumnSearchProps('sdn_paycode_name'),       
	    },
	    {
	        title: <div className="text-right">Total Amount</div>,
	        dataIndex: 'sdn_total_amount',
	        key: 'sdn_total_amount',
	        width: '10%',
	        render: (sdn_total_amount) => <div className="text-right">{NumberFormatter(sdn_total_amount)}</div>
	    },
	    {
	        title: `Status`,
	        dataIndex: 'sdn_status_name',
	        key: 'sdn_status_name',
	        width: '10%',
	    },
	    {
	        title: `Payroll Type`,
	        dataIndex: 'sdn_type_name',
	        key: 'sdn_type_name',
	        width: '10%',
	    },
	    {
	        title: <PopupButton id="add_salary_addition" title="Add Salary Addition" label="Add" btnClass="btn-small" modalWidth={1200}>
						<SalaryAdditionForm recordId="0" mode="edit"/>
					</PopupButton>,
	        dataIndex: 'sdn_id',
	        key: 'sdn_id',
	        width: '10%',
	        render:(sdn_id) => <CrudOption baseRoute="/console/salary-additions" recordId={sdn_id} deleteHandler={doDelete}/>
	    },
    ];
    
    useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

  	return (
	    <Card extra={"w-full h-full p-4"} {...props}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		
	      		<SearchFilter searchHandler={doSearch} filters={filters} pagination={pagination}/>
	      		
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.sdn_id}
		        	pagination={pagination}    
		            onChange={handleTableChange(doSearch, filters)}                	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.salaryAddition.salaryAdditionList?.items,
	pagination: state.salaryAddition.salaryAdditionList?.pagination,
	filters: state.salaryAddition.salaryAdditionList?.filters,
  	requesting: state.salaryAddition.salaryAdditionList?.requesting,
  	error: state.salaryAddition.salaryAdditionList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getSalaryAdditionList(filters)),
  	doDelete: (id) => dispatch(doSalaryAdditionDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryAdditionTable);